import {
  isDesktop,
  isMobile,
  isMobileOnly,
  isTablet,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from 'react-device-detect';

type Environment = {
  isMobile: boolean;
  isMobileOnly: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

// Chrome identifies itself by default as "LG Nexus 5" with Android 6.0 when in device emulation mode (ie. _without_ any specific device selected).
// This is different to Firefox which only identifies itself as mobile device when you actually choose a particular model.
// When you are just changing screen size it remains a "desktop", which makes more sense imho.
// To avoid confusion during testing, we treat chromes default as if it were desktop aswell.
const isChromeDeviceEmulationDefaultDevice =
  mobileVendor === 'LG' &&
  mobileModel === 'Nexus 5' &&
  osName === 'Android' &&
  osVersion === '6.0' &&
  // a real user should be identified correctly
  import.meta.env.MODE !== 'production';

export const useEnvironment = (): Environment => {
  return {
    isMobile: isMobile && !isChromeDeviceEmulationDefaultDevice,
    isMobileOnly: isMobileOnly && !isChromeDeviceEmulationDefaultDevice,
    isTablet,
    isDesktop: isDesktop || isChromeDeviceEmulationDefaultDevice,
  };
};
